// Auth endpoint paths — module-scoped per the post-migration rule.
// Path strings live in the module that owns the API surface; never
// hardcoded inside endpoint functions.
export const AUTH_ENDPOINTS = {
  LOGIN: '/api/auth/login',
  VERIFY_OTP: '/api/auth/verify-otp',
  RESEND_OTP: '/api/auth/resend-otp',
  LOGOUT: '/api/auth/logout',
  UAE_PASS_AUTHORIZE_URL: '/api/auth/uae-pass/authorize-url',
  UAE_PASS_CALLBACK: '/api/auth/uae-pass/callback',
  UAE_PASS_REGISTER: '/api/auth/uae-pass/register',
  // Authenticated — enable (GET authorize-url) / disable (DELETE) UAE Pass from Account Settings.
  UAE_PASS_LINK_AUTHORIZE_URL: '/api/auth/uae-pass/link/authorize-url',
  UAE_PASS_LINK: '/api/auth/uae-pass/link',
  // Authenticated — authoritative enabled-login-method state for Account Settings.
  LOGIN_METHODS: '/api/auth/login-methods',
  PRIVACY_POLICY: '/api/privacy-policy',
  TERMS_AND_CONDITIONS: '/api/tnc',
} as const
